import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App.tsx';
import { HeroProvider } from './components/HeroIcon.tsx';
import { ItemProvider } from './components/ItemIcon.tsx';
import { AbilityProvider } from './components/AbilityIcon.tsx';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Match data changes only when a refresh runs, so avoid refetch churn.
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Do not retry client errors — a 404 will stay a 404.
        const status = (error as { status?: number }).status;
        if (typeof status === 'number' && status >= 400 && status < 500) return false;
        return failureCount < 2;
      },
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <HeroProvider>
          <ItemProvider>
            <AbilityProvider>
              <App />
            </AbilityProvider>
          </ItemProvider>
        </HeroProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
